import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, spacing } from 'styles/constants';
export interface IListable {
  first: boolean;
  last: boolean;
  shouldRenderDefaultBackground?: boolean;
}

export const Section = ({
  first,
  last,
  shouldRenderDefaultBackground,
  style,
  ...props
}: BoxProps & IListable) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Box, {
    ...props,
    style: [
      styles.section,
      {
        backgroundColor: shouldRenderDefaultBackground
          ? getDesignToken('background-default')
          : 'transparent',
      },
      isDesktop && first && styles.sectionFirstDesktop,
      last && styles.sectionLast,
      style,
    ],
  });
};

interface ISpacer {
  $isSmall: boolean;
}
export const Spacer = ({ $isSmall, style, ...props }: BoxProps & ISpacer) => {
  const isDesktop = useIsDesktopBreakpoint();
  return React.createElement(Box, {
    ...props,
    style: [styles.spacer, isDesktop && { height: $isSmall ? 78 : 110 }, style],
  });
};

const styles = StyleSheet.create({
  section: {
    paddingHorizontal: 0,
    paddingTop: spacing.$4,
    paddingBottom: spacing.$4,
  },
  sectionFirstDesktop: {
    paddingTop: spacing.$7,
  },
  sectionLast: {
    paddingBottom: spacing.$7,
  },
  spacer: {
    height: 0,
  },
});
